const PageNameList = {
    MAIN: '/',
    WALLET: '/wallet',
    MOBILE_SIGNIN: '/mobile/signin',
    MOBILE_SIGNUP: '/mobile/signup',
    TRADE: '/trade',
    EXCHANGE: '/exchange',
    EXCHANGE_HISTORY: '/exchange/history',
    MOBILE_USERS_DETAIL: '/mobile/users/detail',
    EDIT_USER_INFO_PAGE: '/edit/user/info',
    GUIDE: '/guide',
    TRADE_HISTORY: '/execution',
    SUBMIT_REQUEST: '/submit_request',
    METAVERSE_TRADER: '/metaverse',
};
export default PageNameList;
